import { render, staticRenderFns } from "./ctrader-account-binding-process.html.vue?vue&type=template&id=8e258ef8"
import script from "./ctrader-account-binding-process.html.vue?vue&type=script&lang=js"
export * from "./ctrader-account-binding-process.html.vue?vue&type=script&lang=js"
import style0 from "./ctrader-account-binding-process.html.vue?vue&type=style&index=0&id=8e258ef8&prod&lang=scss"
import style1 from "./ctrader-account-binding-process.html.vue?vue&type=style&index=1&id=8e258ef8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports